/**
 * Route for `igaming-per-brand-responsible-gambling-filters`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPerBrandResponsibleGamblingFiltersPage } from "../features/igaming-per-brand-responsible-gambling-filters/IgamingPerBrandResponsibleGamblingFiltersPage";

export const igamingPerBrandResponsibleGamblingFiltersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-per-brand-responsible-gambling-filters",
	component: IgamingPerBrandResponsibleGamblingFiltersPage,
});

export default igamingPerBrandResponsibleGamblingFiltersRoute;
